'use client';

import { forwardRef } from 'react';
import type { TypographyProps as MantineTypographyProps } from '@mantine/core';
import { Typography as MantineTypography } from '@mantine/core';

// Typography styles native HTML descendants (headings, lists, tables, code, ...) via
// `:where()` rules inside `@layer mantine`, so it's the surface that renders model-written
// markdown. Like Paper it's an unopinionated wrapper: the styling escape hatches (`className`,
// `classNames`, ...) stay open so a call site can tune the prose for its column. `children` is
// already part of the Mantine type here (it extends `ElementProps<'div'>`), so — unlike Paper —
// there's nothing to re-add.
export type TypographyProps = MantineTypographyProps;

export const Typography = forwardRef<HTMLDivElement, TypographyProps>((props, ref) => {
  return <MantineTypography ref={ref} {...props} />;
});
Typography.displayName = 'Typography';
